import React, {FC} from "react";
import {Button} from "primereact/button";
import {PrimeIcons} from "primereact/api";
import {ConfirmDialog} from "primereact/confirmdialog";
import {useNavigate} from "react-router-dom";
import {routes} from "../../../app/routes";
import {useDeleteHotelMutation} from "../../../api/eventsStoreApi";

const Actions: FC<{ row: any }> = ({row}) => {
    const navigate = useNavigate();
    const [visible, setVisible] = React.useState(false);

    const [deleteHotel] = useDeleteHotelMutation();

    return (
        <>
            <div className="flex gap-2">
                <Button
                    label="Update rooms"
                    icon={PrimeIcons.DATABASE}
                    onClick={() => navigate(`${routes.EDIT}/${row.id}/${routes.ROOMS}`)}
                />
                <Button
                    label="Edit"
                    icon={PrimeIcons.PENCIL}
                    onClick={() => navigate(`${routes.EDIT}/${row.id}`)}
                />
                <Button
                    label="Delete"
                    icon={PrimeIcons.TRASH}
                    onClick={() => setVisible(true)}
                />
                <ConfirmDialog
                    visible={visible}
                    onHide={() => setVisible(false)}
                    message="Are you sure? This hotel and their rooms will be deleted permanently"
                    header="Confirmation"
                    acceptLabel="Yes"
                    rejectLabel="No"
                    accept={() => deleteHotel({id: row.id})}
                />
            </div>
        </>
    );
};

const hotelActionTemplate = (row: any) => <Actions row={row}/>;
export default hotelActionTemplate;
